import { BASE_URL } from '.';
const tokenData: any = localStorage.getItem('token');
const token = tokenData;
export const api_getVendors = async (pageNo?: number, pageSize?: number) => {
	const page_number = pageNo || 1;
	const page_size = pageSize || 10;
	const uri = `${BASE_URL}/catering/vendors/?page=${page_number}&offset=${page_size}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				authorization: `Bearer ${token}`,
			},
		});

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};
export const api_getVendorsByFilter = async (searchString: string) => {
	const uri = `${BASE_URL}/catering/vendors/filter?searchString=${searchString}`;

	try {
		const response = await fetch(uri, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Bearer ${token}`,
			},
		});
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const data = await response.json();
		return { isSuccess: true, data };
	} catch (error) {
		console.error('Fetch error:', error);
		return { isSuccess: false, message: error };
	}
};

export const api_getVendorById = async (id: string, userId: string) => {
	const uri = `${BASE_URL}/catering/vendors/getById/${id}/${userId}`;
	const response = await fetch(uri, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		},
	}).then((res) => res.json());
	return response;
};

export const api_createVendor = async (payload: any) => {
	const uri = `${BASE_URL}/catering/vendors`;
	try {
		const response = await fetch(uri, {
			method: 'POST',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to create the vendor',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Vendor created successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_editVendor = async (payload: any, vendorId: string) => {
	const uri = `${BASE_URL}/catering/vendors/${vendorId}`;
	try {
		const response = await fetch(uri, {
			method: 'PUT',
			headers: {
				authorization: `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});

		if (!response.ok) {
			return {
				isSuccess: false,
				data: null,
				message: 'Failed to edit the vendor',
			};
		}

		const data = await response.json();
		return {
			isSuccess: true,
			data,
			message: 'Vendor edited successfully',
		};
	} catch (error) {
		return {
			isSuccess: false,
			data: null,
			message: error,
		};
	}
};

export const api_deleteVendor = async (vendorId: string) => {
	const uri = `${BASE_URL}/catering/vendors/remove/${vendorId}`;
	const response = await fetch(uri, {
		method: 'DELETE',
		headers: {},
	}).then((res) => res.json());
	return response;
};
